import { createSlice } from '@reduxjs/toolkit';
import { Country } from 'types/countryType';

interface CountryState {
  country: Country[];
}

const initialState: CountryState = {
  country: [],
};

const countrySlice = createSlice({
  name: 'country',
  initialState,
  reducers: {
    setCountry(state, action) {
      state.country = action.payload;
    },
  },
});

export const { setCountry } = countrySlice.actions;
export default countrySlice.reducer;
